module.exports = __webpack_public_path__ + "media/icons/wa-icon-11303021.png";